import DialogueModal from './DialogueModal';

export default DialogueModal;
